.container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	background-color: #f7f7f7;
}

.content {
	text-align: center;
	padding: 2rem;
}

.titleRow {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
}

.title {
	margin: 0;
	font-size: 1.5rem;
	font-weight: 600;
	color: #1e1e1e;
}

.message {
	margin-top: 0.5rem;
	color: #6c757d;
	font-size: 1rem;
}
